import { render } from "./CreateNewQuestionsModal.vue?vue&type=template&id=6c89502c&scoped=true"
import script from "./CreateNewQuestionsModal.vue?vue&type=script&lang=js"
export * from "./CreateNewQuestionsModal.vue?vue&type=script&lang=js"

import "./CreateNewQuestionsModal.vue?vue&type=style&index=0&id=6c89502c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c89502c"]])

export default __exports__